import { useEffect } from "react";
import "./Modal.scss";

/**
 * 通用弹窗壳：半透明遮罩 + 居中白卡片。
 * 点击遮罩或按 Esc 关闭；点击卡片内部不关闭。
 */
const Modal: React.FC<{
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}> = ({ open, onClose, children }) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="cs-modal__overlay" onClick={onClose}>
      <div className="cs-modal__card" onClick={(e) => e.stopPropagation()}>
        {children}
      </div>
    </div>
  );
};

export default Modal;
